var _defs, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPattern(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 864 864",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill: #d4e6ef;\n      }\n\n      .cls-3 {\n        fill: #72a1c2;\n      }\n\n      .cls-4 {\n        fill: url(#New_Pattern_2);\n      }\n\n      .cls-5 {\n        fill: #fff;\n      }\n\n      .cls-6 {\n        fill: #97bcd7;\n      }\n\n      .cls-7 {\n        fill: #00263e;\n      }\n\n      .cls-8 {\n        fill: #1e5c8f;\n      }\n    "), /*#__PURE__*/React.createElement("pattern", {
    id: "New_Pattern_2",
    "data-name": "New Pattern 2",
    x: 0,
    y: 0,
    width: 56.87,
    height: 88.81,
    patternTransform: "translate(-901.6 88.81)",
    patternUnits: "userSpaceOnUse",
    viewBox: "0 0 56.87 88.81"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 0,
    width: 56.87,
    height: 88.81
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M85.31,75.18v27.26c0,.65-.36,1.25-.93,1.55l-26.68,14.21c-.52.28-1.14.28-1.65,0l-26.68-14.21c-.57-.31-.93-.9-.93-1.55v-27.26c0-.65.36-1.25.93-1.55l26.68-14.22c.52-.28,1.14-.28,1.65,0l26.68,14.22c.57.31.93.9.93,1.55Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "33.03 76.88 33.03 76.91 36.94 74.83 42.4 77.84 56.87 70.13 71.34 77.84 76.8 74.83 80.71 76.91 80.71 76.88 56.87 64.18 33.03 76.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "42.43 90.15 56.87 82.46 71.31 90.15 71.31 77.86 71.34 77.84 56.87 70.13 42.4 77.84 42.43 77.86 42.43 90.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "42.43 90.15 42.43 104.07 56.87 96.37 71.31 104.07 71.31 90.15 56.87 82.46 42.43 90.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "36.94 74.83 33.03 76.91 33.03 82.84 42.4 77.84 36.94 74.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "42.43 77.86 42.4 77.84 33.03 82.84 33.03 95.16 42.43 90.15 42.43 77.86"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M28.44,75.18v27.26c0,.65-.36,1.25-.93,1.55L.83,118.21c-.52.28-1.14.28-1.65,0l-26.68-14.21c-.57-.31-.93-.9-.93-1.55v-27.26c0-.65.36-1.25.93-1.55L-.83,59.41c.52-.28,1.14-.28,1.65,0l26.68,14.22c.57.31.93.9.93,1.55Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "-23.84 76.88 -23.84 76.91 -19.93 74.83 -14.47 77.84 0 70.13 14.47 77.84 19.93 74.83 23.84 76.91 23.84 76.88 0 64.18 -23.84 76.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "-14.44 90.15 0 82.46 14.44 90.15 14.44 77.86 14.47 77.84 0 70.13 -14.47 77.84 -14.44 77.86 -14.44 90.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "-14.44 90.15 -14.44 104.07 0 96.37 14.44 104.07 14.44 90.15 0 82.46 -14.44 90.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14.47 77.84 23.84 82.84 23.84 76.91 19.93 74.83 14.47 77.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "14.44 77.86 14.44 90.15 23.84 95.16 23.84 82.84 14.47 77.84 14.44 77.86"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M56.87,30.78v27.26c0,.65-.36,1.25-.93,1.55l-26.68,14.21c-.52.28-1.14.28-1.65,0L.93,59.59C.36,59.28,0,58.69,0,58.04v-27.26C0,30.13.36,29.53.93,29.23l26.68-14.22c.52-.28,1.14-.28,1.65,0l26.68,14.22c.57.31.93.9.93,1.55Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "12.42 60.5 12.42 60.5 28.44 51.97 44.45 60.5 44.45 60.5 28.44 69.04 12.42 60.5"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "4.6 32.48 4.6 32.51 8.51 30.42 13.96 33.44 28.44 25.73 42.91 33.44 48.36 30.42 52.27 32.51 52.27 32.48 28.44 19.77 4.6 32.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.99 45.75 28.44 38.05 42.88 45.75 42.88 33.45 42.91 33.44 28.44 25.73 13.96 33.44 13.99 33.45 13.99 45.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "13.99 45.75 13.99 59.66 28.44 51.96 42.88 59.66 42.88 45.75 28.44 38.05 13.99 45.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "8.51 30.42 4.6 32.51 4.6 38.43 13.96 33.44 8.51 30.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "13.99 33.45 13.96 33.44 4.6 38.43 4.6 50.76 13.99 45.75 13.99 33.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "12.42 60.5 13.99 59.66 13.99 45.75 4.6 50.76 4.6 56.33 12.42 60.5 12.42 60.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "42.91 33.44 52.27 38.43 52.27 32.51 48.36 30.42 42.91 33.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "42.88 33.45 42.88 45.75 52.27 50.76 52.27 38.43 42.91 33.44 42.88 33.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "44.45 60.5 42.88 59.66 42.88 45.75 52.27 50.76 52.27 56.33 44.45 60.5"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M85.31-13.63V13.63c0,.65-.36,1.25-.93,1.55l-26.68,14.21c-.52.28-1.14.28-1.65,0l-26.68-14.21c-.57-.31-.93-.9-.93-1.55V-13.63c0-.65.36-1.25.93-1.55l26.68-14.22c.52-.28,1.14-.28,1.65,0l26.68,14.22c.57.31.93.9.93,1.55Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "40.85 16.1 40.85 16.1 56.87 7.56 72.89 16.1 72.89 16.1 56.87 24.63 40.85 16.1"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "42.43 1.34 56.87 -6.35 71.31 1.34 71.31 -10.95 71.34 -10.97 56.87 -18.68 42.4 -10.97 42.43 -10.95 42.43 1.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "42.43 1.34 42.43 15.26 56.87 7.56 71.31 15.26 71.31 1.34 56.87 -6.35 42.43 1.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "42.43 -10.95 42.4 -10.97 33.03 -5.97 33.03 6.35 42.43 1.34 42.43 -10.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "40.85 16.1 42.43 15.26 42.43 1.34 33.03 6.35 33.03 11.93 40.85 16.1 40.85 16.1"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M28.44-13.63V13.63c0,.65-.36,1.25-.93,1.55L.83,29.4c-.52.28-1.14.28-1.65,0l-26.68-14.21c-.57-.31-.93-.9-.93-1.55V-13.63c0-.65.36-1.25.93-1.55L-.83-29.4c.52-.28,1.14-.28,1.65,0l26.68,14.22c.57.31.93.9.93,1.55Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "-16.02 16.1 -16.02 16.1 0 7.56 16.02 16.1 16.02 16.1 0 24.63 -16.02 16.1"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "-14.44 1.34 0 -6.35 14.44 1.34 14.44 -10.95 14.47 -10.97 0 -18.68 -14.47 -10.97 -14.44 -10.95 -14.44 1.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "-14.44 1.34 -14.44 15.26 0 7.56 14.44 15.26 14.44 1.34 0 -6.35 -14.44 1.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "14.44 -10.95 14.44 1.34 23.84 6.35 23.84 -5.97 14.47 -10.97 14.44 -10.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "16.02 16.1 14.44 15.26 14.44 1.34 23.84 6.35 23.84 11.93 16.02 16.1"
  })))))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 0,
    width: 864,
    height: 864
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 0,
    width: 864,
    height: 864
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPattern);
export default __webpack_public_path__ + "static/media/pattern.e73380026a3850c49bbc2ffda6a485d2.svg";
export { ForwardRef as ReactComponent };